import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import NoAccess from './NoAccess';

export const Loading = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>
);

/** App host: requires a logged-in session (optionally a super admin). */
export default function ProtectedRoute({ children, superAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Loading />;
  if (!user) {
    const next = encodeURIComponent(window.location.origin + location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (superAdmin && !user.is_super_admin) return <NoAccess message="Super admin access required" />;
  return children;
}

/** Tenant host: requires a permission in the current organization. */
export function RequirePermission({ perm, children }) {
  const { can } = useTenant();
  if (!can(perm)) return <NoAccess title="Not allowed" message="Your role in this organization can't open this page." />;
  return children;
}
